import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
import Tool from '../views/Tool'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/tool',
      component: Tool
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js